export const RECAPTCHA_TOKEN_FIELD = 'g-recaptcha-response';
export const RECAPTCHA_VERIFICATION_FAILED = 'recaptcha_verification_failed';
